import { H2RInput } from "../imports";

export default function OffsetOption({ cue, onUpdate }) {
	return (
		<>
			<OffsetOptionPosition cue={cue} onUpdate={onUpdate} />

			<H2RInput
				key={`scale_${cue.id}`}
				type="range"
				label="Scale"
				labelValue={`${cue.scale || 100}`}
				labelValueEditable={true}
				min="1"
				max="400"
				resetValue="100"
				step={0.5}
				value={cue.scale || 100}
				onChange={(change) => {
					onUpdate({ scale: change });
				}}
			/>
			<H2RInput
				key={`x_${cue.id}`}
				type="range"
				label="X"
				labelValue={`${cue.offsetX || "0"}`}
				labelValueEditable={true}
				min="-100"
				max="100"
				resetValue="0"
				step={0.5}
				value={cue.offsetX || "0"}
				onChange={(change) => {
					onUpdate({ offsetX: change });
				}}
			/>
			<H2RInput
				key={`y_${cue.id}`}
				type="range"
				label="Y"
				labelValue={`${cue.offsetY || "0"}`}
				labelValueEditable={true}
				min="-100"
				max="100"
				resetValue="0"
				step={0.5}
				value={cue.offsetY || "0"}
				onChange={(change) => {
					onUpdate({ offsetY: change });
				}}
			/>
			<H2RInput
				key={`rotate_${cue.id}`}
				type="range"
				label="Rotate"
				labelValue={`${cue.rotate || "0"}`}
				labelValueEditable={true}
				min="-180"
				max="180"
				resetValue="0"
				step={0.5}
				value={cue.rotate || "0"}
				onChange={(change) => {
					onUpdate({ rotate: change });
				}}
			/>
		</>
	);
}

const OffsetOptionPosition = ({ cue, onUpdate }) => {
	let array = ["tl", "tc", "tr", "ml", "mc", "mr", "bl", "bc", "br"];

	if (cue.type === "lower_third" && cue.useCustomImage === true) {
		array = ["bl", "br"];
	}

	return (
		<div className="flex flex-col mx-auto space-y-2">
			<span className="flex space-x-2">
				<OffsetOptionPositionInternal
					id={cue.id}
					position="tl"
					selected={cue.position || "mc"}
					disabled={!array.includes("tl")}
					onUpdate={onUpdate}
				/>
				<OffsetOptionPositionInternal
					id={cue.id}
					position="tc"
					selected={cue.position || "mc"}
					disabled={!array.includes("tc")}
					onUpdate={onUpdate}
				/>
				<OffsetOptionPositionInternal
					id={cue.id}
					position="tr"
					selected={cue.position || "mc"}
					disabled={!array.includes("tr")}
					onUpdate={onUpdate}
				/>
			</span>
			<span className="flex space-x-2">
				<OffsetOptionPositionInternal
					id={cue.id}
					position="ml"
					selected={cue.position || "mc"}
					disabled={!array.includes("ml")}
					onUpdate={onUpdate}
				/>
				<OffsetOptionPositionInternal
					id={cue.id}
					position="mc"
					selected={cue.position || "mc"}
					disabled={!array.includes("mc")}
					onUpdate={onUpdate}
				/>
				<OffsetOptionPositionInternal
					id={cue.id}
					position="mr"
					selected={cue.position || "mc"}
					disabled={!array.includes("mr")}
					onUpdate={onUpdate}
				/>
			</span>
			<span className="flex space-x-2">
				<OffsetOptionPositionInternal
					id={cue.id}
					position="bl"
					selected={cue.position || "mc"}
					disabled={!array.includes("bl")}
					onUpdate={onUpdate}
				/>
				<OffsetOptionPositionInternal
					id={cue.id}
					position="bc"
					selected={cue.position || "mc"}
					disabled={!array.includes("bc")}
					onUpdate={onUpdate}
				/>
				<OffsetOptionPositionInternal
					id={cue.id}
					position="br"
					selected={cue.position || "mc"}
					disabled={!array.includes("br")}
					onUpdate={onUpdate}
				/>
			</span>
		</div>
	);
};

const OffsetOptionPositionInternal = ({
	id,
	position,
	selected,
	disabled,
	onUpdate,
}) => {
	return (
		<button
			disabled={disabled}
			className={`h-5 w-10 rounded-sm focus:outline-none focus:ring ring-main-500
					${selected === position ? "bg-main-500" : "bg-gray-700"}
					${disabled && "cursor-not-allowed bg-gray-800 border border-gray-700"}
			`}
			onClick={() => {
				onUpdate({ position });
			}}
		></button>
	);
};
